import React, { useEffect, useRef } from "react";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import VariablePieChart from "./Charts/VariablePieChart";

// Register necessary components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
);

const Chart = ({ type, data, options }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chartInstance = chartRef.current?.chart;
    return () => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    };
  }, []);

  const renderChart = () => {
    switch (type) {
      case "bar":
        return <Bar ref={chartRef} data={data} options={options} />;
      case "line":
        return <Line ref={chartRef} data={data} options={options} />;
      case "pie":
        return <VariablePieChart data={data} options={options} />;
      // return <Pie ref={chartRef} data={data} options={options} />;
      default:
        return <Line ref={chartRef} data={data} options={options} />;
    }
  };

  return renderChart();
};

export default Chart;
